export default "__VITE_ASSET__BWKrh8hS__"